import React from "react";
import { SectionIndicator } from "../sectionIndicator/SectionIndicator";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";

type props = {
  title?: string;
  color?: string;
};

export const SelectCircleInitialHeader: React.FC<props> = ({ title, color }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 10,
        alignItems: "center",
      }}>
      <SectionIndicator color={color ? Colors.green:"white"} number="2" />
      <TCText
        style={{ fontWeight: 600, fontSize: 14, color: color ? "black":"white" }}
        value={title ?? "Select the players you want play with"}
      />
    </div>
  );
};
